// extracted by mini-css-extract-plugin
export var container = "styles-module--container--jqnpZ";
export var copyright = "styles-module--copyright--hamqF";
export var footerAccueil = "styles-module--footer-accueil--xPT-q";
export var item = "styles-module--item--T+drs";
export var listInlineItem = "styles-module--list-inline-item--r0ToY";
export var row = "styles-module--row--kuhao";
export var social = "styles-module--social--TNFTZ";